<template lang='pug'>
//- ChatGPT翻譯結果
div(:class='$style[`cc-popbox-translator`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.font-doctor-theme 翻
        span.font-normal-theme 譯
        span.no-wrap 內容
        //- span.no-wrap 結果 → {{ detail.language }}

  div.font-medium(:class='$style[`cc-content-translator-result`]')
    //- div(v-if='detail.feature === `create`' :class='$style[`cc-content-translator-result-tips`]')
    //-   != '本次翻譯 -3'
    //-   IconCcoin(:size='17')

    div(:class='$style[`cc-content-translator-result-tips`]') 建立日期：{{ detail.date }}

    div(:class='$style[`cc-content-translator-result-content`]')
      span {{ detail.completion }}

    div(:class='$style[`cc-content-translator-result-interactive`]')
      div(:class='$style[`cc-content-translator-result-origin`]')
        span 原文：{{ detail.origin }}

  div(
    v-if='detail.feature === `create`'
    :class='$style[`cc-content-translator-controll`]')
    div(:class='$style[`cc-content-translator-controll-save`]')
      Inputer(
        v-model='saveName'
        title='命名此翻譯紀錄'
        style='width: 250px'
        :class='$style[`cc-input-area`]'
        :resetButton='false'
        :defaultValue='detail.short'
        :placeholder='`命名此翻譯紀錄`'
        :errorValue='saveNameError'
        @clearErrorMsg="(value) => {this.saveNameError = value[0];}")
      button.btn-extra(
        title="保存並關閉"
        tabindex='0' aria-label='保存並關閉'
        :class='$style[`cc-content-translator-controll-btn`]'
        @click='clickStartUpdateProcess')
        span 保存並關閉

  div(
    v-else-if='detail.feature === `edit`'
    :class='$style[`cc-content-translator-controll`]')
    div(:class='$style[`cc-content-translator-controll-save`]')
      Inputer(
        v-model='saveName'
        title='命名此翻譯紀錄'
        style='width: 250px'
        :class='$style[`cc-input-area`]'
        :resetButton='false'
        :defaultValue='detail.short'
        :placeholder='`命名此翻譯紀錄`'
        :errorValue='saveNameError'
        @clearErrorMsg="(value) => {this.saveNameError = value[0];}")

      button.btn-extra(
        title="保存並關閉"
        tabindex='0' aria-label='保存並關閉'
        :class='$style[`cc-content-translator-controll-btn`]'
        @click='clickStartUpdateProcess')
        span 保存並關閉

    //- div(:class='$style[`cc-content-translator-controll-reject`]')
    //-   button.btn-extra(
    //-     title="關閉"
    //-     tabindex='0' aria-label='關閉'
    //-     :class='$style[`cc-content-translator-controll-btn`]'
    //-     @click='handleClosePopBox')
    //-     span 關閉

</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
// var emitter = require('tiny-emitter/instance');
import Inputer from '../common/Input';
import IconLoading from '../../icon/Loading';
import GlobalEmitter from 'tiny-emitter/instance';
import IconCcoin from '../../icon/Ccoin.vue';

import {
  putSaveTranslatorResult,
} from '../../../js/restapi';

export default {
  components: {
    Inputer,
    IconLoading,
    IconCcoin,
  },

  props: {
    detail: null,
  },

  data() {
    return {
      showLoading: false,
      saveName: this.detail.short || '',
      saveNameError: false,

      verifyAllPass: true,
    };
  },

  created() {
    console.log('PopTranslate Details', this.detail);
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopTranslatorStatus: 'global/POPTRANSLATOR_STATUS',
    }),

    handleClosePopBox() {
      this.changePopTranslatorStatus({
        active: false,
        detail: {},
      });
    },

    handleFormsCheckToPass() {
      this.verifyAllPass = true;

      if (!this.saveName) {
        // 內容為空
        this.saveNameError = true;
        this.verifyAllPass = false;
      }
    },

    handleUpdateSaveResultName() {
      if (!this.verifyAllPass) { return; }
      // this.showLoading = true;

      const PASS_DATA = {
        id: this.detail.id,
        // index: this.detail.index,
        short: this.saveName,
      };

      console.log('PASS_DATA', PASS_DATA);

      putSaveTranslatorResult('', PASS_DATA, {})
        .then((res) => {
          // this.showLoading = false;

          this.changePopBoxStatus({
            active: true,
            include: 'updateConfirm',
          });

          if (this.detail.feature === 'edit') {
            GlobalEmitter.emit('update-translation', {
              id: this.detail.id,
              index: this.detail.index || 0,
              auth_id: this.loginDjangoId,
              short: this.saveName,
            });
          } else {
            GlobalEmitter.emit('create-translation', {
              id: this.detail.id,
              auth_id: this.loginDjangoId,
              // completion: this.detail.completion,
              date: this.detail.date,
              language: this.detail.language,
              origin: this.detail.origin,
              short: this.saveName,
              completion: this.detail.completion,
            });
          }

          setTimeout(() => {
            this.changePopTranslatorStatus({
              active: false,
              detail: {},
            });
            this.changePopBoxStatus({
              active: false,
              include: '',
            });
          }, this.POP_DURATION);
        })
        .catch((err) => {
          console.log('putSaveTranslatorResult 失敗', err);
        });
    },

    async clickStartUpdateProcess() {
      await this.handleFormsCheckToPass();
      await this.handleUpdateSaveResultName();
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      authJwtToken: 'user/exportUserJwtToken',
      // loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popTranslatorResult.scss';
</style>
